import { render, staticRenderFns } from "./hjgzb.vue?vue&type=template&id=35c1f24a&scoped=true&"
import script from "./hjgzb.vue?vue&type=script&lang=js&"
export * from "./hjgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1f24a",
  null
  
)

export default component.exports